// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3f843d89","455":"1c721ced","977":"451053b6"}[chunkId] + ".chunk.js";
};